import React, { useState } from "react";
import AxiosInstance from "../../../utils/AxiosInstance";
import { useNetwork } from "../../../context/NetworkContext";
import handleError from "../../../constants/handleError";
import { useShowAlert } from "../../../context/AlertContext";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { CircularProgress } from "@mui/material";
import { RefreshIcon } from "../../../constants/Icons";

const LastSalePriceButton = ({ productId, customerId }) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [lastSalePrice, setLastSalePrice] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [noPrice, setNoPrice] = useState(false);

  const isValidId = (id) => typeof id === "string" && id.trim().length > 0;

  const handleFetchLastPrice = async () => {
    if (!isValidId(productId) || !isValidId(customerId)) return;
    if (!checkNetwork()) return;

    setIsLoading(true);
    setNoPrice(false);
    setLastSalePrice(null);

    try {
      const response = await AxiosInstance.get(
        `module/sale/recent/${productId}?customerid=${customerId}`
      );
      const results = response?.data?.results;
      const saleItems = Array.isArray(results) && results[0]?.saleitems;
      const prices = Array.isArray(saleItems)
        ? saleItems.map((item) => item?.soldprice).filter((p) => p != null)
        : [];

      if (prices.length > 0) {
        setLastSalePrice(prices);
      } else {
        setNoPrice(true);
      }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setIsLoading(false);
    }
  };

  const isDisabled =
    isLoading || !isValidId(productId) || !isValidId(customerId);

  return (
    <div className="text-center mb-1">
      <p className="mb-0 fs-14">
        <strong> Last Sale Price : </strong>
        {Array.isArray(lastSalePrice) && lastSalePrice.length > 0 ? (
          <span className="badge bg-label-fall rounded-pill">
            ₹{CurrencyConverter.toCurrency(lastSalePrice[0] || 0, "INR")}
          </span>
        ) : noPrice ? (
          <span className="badge bg-label-danger rounded-pill">
            No Sale Price
          </span>
        ) : (
          <button
            onClick={handleFetchLastPrice}
            disabled={isDisabled}
            type="button"
            className="btn btn-sm badge bg-label-fall rounded-pill shadow-none "
          >
            {isLoading ? (
              <>
                <button
                  className="btn btn-sm badge bg-label-fall rounded-pill shadow-none"
                  disabled
                >
                  <CircularProgress size={1} className="text-white" />
                </button>
              </>
            ) : (
              <>
                <RefreshIcon/> Show
              </>
            )}
          </button>
        )}
      </p>
    </div>
  );
};

export default LastSalePriceButton;
